<template>
  <div>
    <!-- Pricing Box Starts -->
    <div class="pricingPlan-bottom_img" style="position: relative;">
      <img style="width:100%;height:50vh" v-if="pricingPlanlist.position1.length>0" :src="pricingPlanlist.position1[0].thumb" />
      <p v-if="false" style="position: absolute;
              color: #fff;
              bottom: 10vh;
              font-size: 6vh;
              left: 12%;
              border-bottom: 2px solid #ccc;
              font-weight: 600;">{{ pricingPlanlist.position1[0].title }}</p>
    </div>
    <div class="pricing-box section-padding3">
      <div class="container">
        <div class="row">
          <!-- v-for="(item, index) in pricingPlanlist.position2" :key="index" -->
          <div v-if="pricingPlanlist.position2.length>0" class="col-md-5" style="background-color: #F9F9F9;padding: 0 0;margin: 1vh 2vw;">
            <div class="single-box1 text-center mb-4 mb-md-0">
              <img style="width:100%;height:auto" :src="pricingPlanlist.position2[0].thumb" />
            </div>
            <div style="padding: 5px 20px">
              <h4>{{ pricingPlanlist.position2[0].title }}</h4>
              <p>{{ pricingPlanlist.position2[0].brief }}</p>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row" style="height: 100%;display: flex; align-content: space-around;  align-items: flex-start; flex-wrap: wrap;">
              <div class="col-md-4"  v-for="(item, index) in pricingPlanlist.position3" :key="index">
                <ul v-if="index<9" @click="detailClick(item.id)">
                  <li>
                    <img class="sass-img" :src="item.thumb" />
                  </li>
                  <li class="sass_title">{{item.title }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Pricing Box End -->
  </div>
</template>
<script>
import { us } from '@/api/index'
import axios from "axios";

export default {
  data() {
    return {
      pricingPlanlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: [],
      },
    }
  },
  mounted() {
    this.getus(this.$route.query.id)
  },
  methods: {
    detailClick(id){
      // this.$router.push({
      //   path: '/detail',
      //   query:{
      //     id:id
      //   }
      // })
    },
    getus(id) {
      axios.get('http://cms.saveus.cn/api/ttg/page?id='+id).then(res=>{
        let list = res.data.data;

        for (let index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            this.pricingPlanlist.position1.push(list[index])
          } else if (list[index].position == 2) {
            this.pricingPlanlist.position2.push(list[index])
          } else if (list[index].position == 3) {
            list[index].status1 = false
            this.pricingPlanlist.position3.push(list[index])
          } else if (list[index].position == 4) {
            this.pricingPlanlist.position4.push(list[index])
          }
        }
      })
    },
  },
}
</script>
<style >
@media (min-width: 280px) {
  .sass-img {
    width: 100%;
    height: 30vh;
    position: relative;
    padding: .1vh 0vh;
  }

  .sass_title {
    width: 100%;
    text-align: center;
    position: absolute;
    font-size: 3vh;
    color: #fff;
    bottom: 25%;
  }

  .section-padding3 {
    padding-bottom: 0vh !important;
  }

  .col-md-4 {
    padding-right: 0px;
    padding-left: 0px;
  }

  .pricingPlan-bottom_img {
    height: 50vh;
    /* background:url(/static/assets/images/hezuo.png); */
    /* background-size: 100% 100%; */
    /* background-repeat: no-repeat; */
  }
    .icon_box{
    height:10vh;display: flex;justify-content: flex-end;
    display: none;
  }
}

@media (min-width: 1200px) {
  .row{
    padding: 10px;
  }
  .col-md-4 {
    padding-right: 10px;
    padding-left: 10px;
  }

  .sass-img {
    width: 100%;
    height: 100px;
  }

  .sass_title {
    position: static;
    color: black;
    font-size: 14px;
    font-weight: 500;

  }

  .pricingPlan-bottom_img {

    height: 50vh;
    /* background:url(/static/assets/images/hezuo.png); */
    /* background-size: 100% 100%; */
    /* background-repeat: no-repeat; */
  }
  .icon_box{
    display: block;
    padding-right: 80px;
    align-items: center;
    height:10vh;display: flex;justify-content: flex-end;
  }
}
</style>




// WEBPACK FOOTER //
// PricingPlan.vue?27f4fe06